/*jshint esversion: 6 */

import Vue from 'vue';
import Vuex from 'vuex';
import {
  students
} from './firebaseConfig.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    selectedStudent: null,
    activities: [],
    students: [],
    view: 'home',
  },
  mutations: {
    putStudents(state, students) {
      state.students = students;
    },
  },
  actions: {
    loadStudents(context) {
      students.onSnapshot((students) => {
        let studentsList = [];
        let counter = 0;
        students.forEach((student) => {
          studentsList.push(student.data());
          counter++;
          if (counter === students.size) {
            context.commit("putStudents", studentsList);
          }
        });
      });
    },
  }
});